import { Pipe, PipeTransform } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';

@Pipe({
    name: 'webviewDateFormatPipe',
})

export class WebviewDateFormatPipe implements PipeTransform {
    language;

    constructor(
        private _activatedRoute: ActivatedRoute
    ){
        this._activatedRoute.queryParams.subscribe(params => {
            if(params['language']){
                this.language = params['language'];
            }else{
                this.language = 'en'
            }
        })
    }

    transform(value: string, type: any) {
        let toUTC: Boolean = false;
        let format = 'YYYY-MM-DD HH:mm';
        switch (type) {
            case 'webviewDate': {
                if(this.language == 'zh'){
                    moment.lang('zh-hk');
                    format = 'YYYY年M月D日'; // 2018年8月16日
                }else if(this.language == 'cn'){
                    moment.lang('zh-cn');
                    format = 'YYYY年M月D日'; // 2018年8月16日
                }else{
                    moment.lang('en');
                    format = 'D MMM YYYY'; // 16 Aug 2018
                }
                
                break;
            }
            
            case 'webviewDateBtn': {
                if(this.language == 'zh'){
                    moment.lang('zh-hk');
                    format = 'YYYY年M月D日'; // 2018年8月16日
                }else if(this.language == 'cn'){
                    moment.lang('zh-cn');
                    format = 'YYYY年M月D日'; // 2018年8月16日
                }else{
                    moment.lang('en');
                    format = 'D MMM YYYY (ddd)'; // 16 Aug 2018 (Thu)
                }
                break;
            }

            case 'webviewTime': {
                if(this.language == 'zh'){
                    moment.lang('zh-hk');
                    format = 'A h:mm';
                }else if(this.language == 'cn'){
                    moment.lang('zh-cn');
                    format = 'A h:mm'; // 16 Aug (Thu)
                }else{
                    moment.lang('en');
                    format = 'h:mm A'; // 10:00 AM
                }
                break;
            }
        }
        let momentDate = moment(value);
        if(this.language == "cn"){
            moment.updateLocale('zh-cn', {
                meridiem : function (hour, minute, isLowercase) {
                    if (hour < 9) {
                        return "上午";
                    } else if (hour < 12 && minute < 59) {
                        return "上午";
                    } else if (hour < 18) {
                        return "下午";
                    } else {
                        return "下午";
                    }
                }
            });
        }
        if(this.language == 'zh'){
            moment.updateLocale('zh-hk', {
                meridiem : function (hour, minute, isLowercase) {
                    if (hour < 9) {
                        return "上午";
                    } else if (hour < 12 && minute < 59) {
                        return "上午";
                    } else if (hour < 18) {
                        return "下午";
                    } else {
                        return "下午";
                    }
                }
            });
        }

        if(type == 'webviewTime'){
            momentDate = moment(value).utcOffset("+0800");
        }
        return momentDate.format(format);
    }
}